module.exports = "/static/assets/71616158a7b62bb987ae9db090226254.png";